export class MainDetailsContainer {
    constructor($state, $timeout, $stateParams, JFrogEventBus, XRayUtils, JFrogGridFactory, uiGridConstants, User,
                EventXDao, JFrogModal, ScanDao, JFrogNotifications, ComponentsDao, XRayUIPermissions,
                IgnoreModal, CompLicensesDao, XRayUIState, $filter, $window, commonGridColumns, $q, JFrogTableViewOptions) {
        this.$timeout = $timeout;
        this.$state = $state;
        this.$q = $q;
        this.commonGridColumns = commonGridColumns;
        this.user = User;
        this.scanDao = ScanDao;
        this.IgnoreModal = IgnoreModal;
        this.$window = $window;
        this.XRayUIPermissions = XRayUIPermissions;
        this.$filter = $filter;
        this.XRayUIState = XRayUIState;
        this.componentsDao = ComponentsDao;
        this.showAboutBox = true;
        this.issueQuery = "";
        this.jFrogNotifications = JFrogNotifications;
        this.compLicensesDao = CompLicensesDao;
        this.jfrogEventBus = JFrogEventBus;
        this.EVENTS = JFrogEventBus.getEventsDefinition();
        this.$stateParams = $stateParams;
        this.user = User.getCurrent();
        this.treeDir = $stateParams.treeDir || 'des';
        this.eventxDao = EventXDao;
        this.modal = JFrogModal;
        this.jfrogGridFactory = JFrogGridFactory;
        this.buildTabsInProgress = false;
        this.fetchIssuesInProgress = false;
        this.showTree = true;
        this.uiGridConstants = uiGridConstants;
        this.$stateParams.tab = '';
        this.defaultPagination = {direction: 'asc', num_of_rows: 25, order_by: 'severity', page_num: 1}
        this.defaultLicensesPagination = {
            direction: 'asc',
            num_of_rows: 25,
            order_by: 'severity',
            page_num: 1,
            type: 'license'
        }

        this.xrayUtils = XRayUtils;
        this._createIssuesGrid();
        this._createLicenseGrid();
        this._createFilesGrid();
        this.baseTabsDict = {};
        this.versionOfComp = "";
        this.currentSwitch = 'vuls';
        this.currentLicensesSwitch = 'licenses';


        this.eventXDao = EventXDao;
        this.$timeout(() => {
            this.$widgetObject.showSpinner = false;
        });
        this.switchesCount = {};
        this.showVersions = true;
        this.setDebounceMethod();
        let removeUpdateListener = JFrogEventBus.register(this.EVENTS.COMPONENT_DATA_UPDATED, (data) => {
            let hasLatestVersionView = false;
            if (data.latest_versions) {
                hasLatestVersionView = data.latest_versions.internal_permissions.readable;

            }

            if (data.pkg_type === 'generic' || data.hide_versions_menu || hasLatestVersionView) {
                this.buildTabs(data);
            }

            if (data.pkg_type) {
                this.rootComponentType = data.pkg_type;
            }
            if (data.version) {
                this.versionNumber = data.version;
            }
            //this.getRootData();
        });

        let removeVersioneListener = JFrogEventBus.register(this.EVENTS.COMPONENT_VERSION_SELECTED, (data) => {

            this.buildTabs(data, 'force');
            this.$timeout(() => {

                this.refreshGrid();

            });

        });
        let removeCustomIssueListener = JFrogEventBus.register(this.EVENTS.CUSTOM_ISSUE_ADDED, () => {
            this.buildTabs({}, 'force')
        });

        this.$timeout(() => {

            this.$scope.$on('$destroy', () => {
                removeUpdateListener();
                removeVersioneListener();
                removeCustomIssueListener();
                //$(document).off();
            });
        }, 500);



        this.$timeout(() => {
            this.tableViewOptions = new JFrogTableViewOptions(this.$scope);

            this.$scope.$on('$destroy', () => {
                this.XRayUIState.removeState('lastTabClicked');
            });

            if (this.$widgetObject.model.sharedData.compDetails) {
                //this.buildTabs(this.$widgetObject.model.sharedData.compDetails);
            }
            if (!this.XRayUIState.getState('lastTabClicked')) {

                this.currentTab = 'violations';
            }
            else {
                this.currentTab = this.XRayUIState.getState('lastTabClicked');
            }
        });

        this.setClickEventListener();


        /*this.$timeout(() => {
            //console.log('refreshing grid')
            this.refreshGrid();
        },5000)*/
    }

    onSwitchChange() {

        if (this.rootIsScannable && this.switchesCount.security) {
            this.currentSwitch = this.issues_switchedValue.toLowerCase().indexOf('watch') > -1 ? 'watch' : 'vuls';
        } else {
            this.currentSwitch = 'vuls';
        }

    }

    getFullCompId() {
        let ver = '';
        if (this.$widgetObject.model.sharedData.currentVersion) {
            ver = ':' + this.$widgetObject.model.sharedData.currentVersion.version_number;
        }
        return this.$stateParams.componentID + ver;
    }

    onLicenseSwitchChange() {

        if (this.rootIsScannable && this.switchesCount.licenses) {
            this.currentLicensesSwitch = this.licenses_switchedValue.toLowerCase().indexOf(
                'watch') > -1 ? 'licenses-watch' : 'licenses';
        } else {
            this.currentLicensesSwitch = 'licenses';
        }
    }

    onChangeTab(tab) {

        if ($('.vakata-context').length > 0) {
            $('.vakata-context').hide();
        }

        if (tab) {

            console.log("Tab Changed", tab);
            this.currentTab = tab.name;
        }

        if (this.currentTab === 'ancestors') {
            this.treeDir = 'anc';
        }
        if (this.currentTab === 'descendants') {
            this.treeDir = 'des';
        }


        if (this.currentTab === 'issues') {
            this.$timeout(() => {
                //this.getIssues();
                this.refreshGrid();
            }, 500)

        }
        if (this.currentTab === 'licenses') {
            this.getLicenses();
        }
        if (this.currentTab === 'locations') {
            this.getLocations();
        }
        if (this.currentTab === 'violations') {
            this.getIssues(false);

            this.$timeout(() => {
                $('.group-button').on('click', () => {
                    this.userIssuesGridOptions.refreshColumns();
                });
            }, 500);
        }

    }

    buildTabs(details, type = "normal", buildAncestors = true) {

        if (!this.buildTabsInProgress) {
            this.buildTabsInProgress = true;
            //this.hasViolations = false;
            //this.showTabs = false;
            this.showActions = false;

            let payload = {};
            payload.package_id = this.$stateParams.componentID;

            if (this.$widgetObject.model.sharedData.currentVersion) {
                if (this.$widgetObject.model.sharedData.currentVersion.version_number) {
                    payload.version = this.$widgetObject.model.sharedData.currentVersion.version_number;
                }
            }


            this.componentsDao.getInfoTabs(payload).$promise.then((data) => {
                let tabs;
                if (data.is_root) {
                    tabs = ['violations', 'issues', 'licenses', 'locations', 'descendants', 'ancestors'];
                } else {
                    tabs = ['issues', 'licenses', 'locations', 'descendants', 'ancestors'];
                    this.getIssues();
                }
                this.rootIsScannable = data.is_root;
                if (data.is_docker_component_layer) {
                    this.isDockerLayer = data.is_docker_component_layer;
                }
                if (data.permissions) {
                    if (data.permissions.manageable == true) {
                        this.manageable = true;
                    } else {
                        this.manageable = false;
                    }
                    this.buildTabsInProgress = false;
                }


                this.showActions = true;
                if (data.issues) {
                    this.hasIssueCount = true;
                    this.hasIssues = true;
                } else {
                    this.hasIssueCount = false;
                    this.hasIssues = false;
                }
                if (data.licenses) {
                    this.hasLiceCount = true;

                } else {
                    this.hasLiceCount = false;
                }

                let violationsCount = 0;
                this.tabs = [];
                _.forEach(tabs, (n, key) => {

                    let obj = {};
                    obj.name = n;
                    obj.class = n;
                    if (data[n] || n == 'violations') {
                        if (n == 'issues') {
                            this.baseTabsDict[n] = 'Security' + ' (' + data[n].toString() + ')';

                        }
                        else if (n == 'violations') {
                            if (data.user_issues) {
                                violationsCount += data.user_issues;
                            }
                            this.baseTabsDict[n] = 'Violations' + ' (' + violationsCount.toString() + ')';
                            if (violationsCount == 0) {
                                this.hasViolations = false;
                            } else {
                                this.hasViolations = true;
                            }
                        }
                        else {
                            this.baseTabsDict[n] = _.capitalize(n) + ' (' + data[n].toString() + ')';
                        }
                    }
                    else {
                        if (n == 'locations' || n == 'issues' || n == 'licenses') {

                            if (n == 'issues') {
                                this.baseTabsDict[n] = 'Security' + ' (0)';
                            } else {
                                this.baseTabsDict[n] = _.capitalize(n) + ' (0)';
                            }
                        } else {
                            this.baseTabsDict[n] = _.capitalize(n);
                        }
                    }

                    this.tabs.push(obj);

                });

                this.tabsDict = _.cloneDeep(this.baseTabsDict);


                if (!this.XRayUIState.getState('lastTabClicked')) {

                    this.$stateParams.tab = this.tabs[0].name;
                    this.currentTab = this.tabs[0].name;

                } else {

                    let prevTab;
                    this.XRayUIState.getState(
                        'lastTabClicked') == 'security' ? prevTab = 'issues' : prevTab = this.XRayUIState.getState(
                        'lastTabClicked');
                    this.$stateParams.tab = prevTab;
                    this.currentTab = prevTab;

                }


                if (this.$widgetObject.model.sharedData.currentVersion) {
                    this.versionOfComp = ':' + this.$widgetObject.model.sharedData.currentVersion.version_number;
                } else if (this.$widgetObject.model.sharedData.compDetails.general_details.type.toLowerCase() !== 'file' && !this.$widgetObject.model.sharedData.compDetails.general_details.hide_versions_menu) {
                    this.versionOfComp = ':' + this.$widgetObject.model.sharedData.compDetails.general_details.latest_versions.internal_version;
                } else {
                    this.versionOfComp = '';
                }

                this.showSwitch = true;
                this.$timeout(() => {
                    $(document).trigger('resize');
                });
            });


            this.$timeout(() => {
                this.showTabs = true;
                this.clickTab(this.getLastVisitedTab());

                if (this.currentTab == 'issues' || this.currentTab == 'violations') {
                    this.refreshGrid();
                    if (this.currentTab == 'violations') {
                        this.getIssues(false);
                        this.$timeout(() => {
                            $('.group-button').on('click', () => {

                                this.userIssuesGridOptions.refreshColumns();

                            });
                        }, 500);
                    }
                }
                if (this.currentTab === 'licenses') {
                    this.getLicenses();
                } else if (this.currentTab === 'locations') {
                    this.getLocations();
                } else if (this.currentTab === 'ancestors' || this.currentTab === 'descendants') {
                    this.showTree = false;

                    this.$timeout(() => {
                        this.showTree = true;
                    }, 500);
                }

            });

            if (type == 'force') {
                delete this.issues;
                delete this.licenses;
                delete this.locations;

            }
        }

    }


    _createIssuesGrid() {
        this.$timeout(() => {
            this.issuesGridOptions = this.jfrogGridFactory.getGridInstance(this.$scope)
                .setRowTemplate('default')
                .setColumns(this._getIssuesGridColumn())
                .setButtons(this._getIssuesActions())
                .setExternalPagination((pagination) => this.getIssues(true, pagination))
                .setGridData([]);
            this.issuesGridOptions.ctrl = this;

            this.userIssuesGridOptions = this.jfrogGridFactory.getGridInstance(this.$scope)
                .setRowTemplate('default')
                .setColumns(this._getUserIssuesGridColumn())
                .setButtons(this._getIssuesActions())
                .setGridData([]);

        });
    }

    _createLicenseGrid() {

        this.$timeout(() => {

            this.licenseGridOptions = this.jfrogGridFactory.getGridInstance(this.$scope)
                .enableSubRows()
                .setRowTemplate('default')
                /*  .allowColumnsCustomization()*/
                .setKey((row) => {
                    return row.name;
                })
                .setRowsPerPage(25)
                .setColumns(this._getLicenseGridColumn())
                .setButtons(this._getLicensesActions())
        });
    }

    _createFilesGrid() {
        this.$timeout(() => {
            this.filesGridOptions = this.jfrogGridFactory.getGridInstance(this.$scope)
                .setRowTemplate('default')
                .setRowsPerPage(25)
                .setColumns(this._getFilesGridColumn());
        });
    }


    _getIssuesGridColumn() {
        return [
            {
                name: 'Summary',
                displayName: 'Summary',
                field: "summary",
                cellTemplate: `<div ng-click="grid.options.ctrl.ShowIssueModal(row.entity.id,row.entity.component,'issue',row.entity)"
 class="ui-grid-cell-contents"><a class="jf-link">{{row.entity.summary}}</a></div>`,
                width: '40%'
            },
            {
                name: 'Severity',
                displayName: 'Severity',
                cellTemplate: '<div ng-class="[row.entity.severity.toLowerCase()]" class="severity ui-grid-cell-contents">{{row.entity.severity}}</div>',
                field: "severity",
                sort: {
                    direction: this.uiGridConstants.DESC
                },
                width: '10%'
            },
            {
                name: 'Issue Type',
                displayName: 'Issue Type',
                cellTemplate: `<div class="ui-grid-cell-contents">{{row.entity.issue_type | capitalizeFirst}}</div>`,
                field: 'issue_type',
                width: '10%'
            },
            {
                name: 'Component',
                displayName: 'Component',
                field: "component",
                cellTemplate: `<div  ui-sref="components.details({componentID: row.entity.source_id,componentVersion:grid.options.ctrl.xrayUtils.getVer(row.entity.source_comp_id)})" class="ui-grid-cell-contents"><a class="jf-link" ng-if="row.entity.source_comp_id.split('://')[0] == 'generic'">{{row.entity.component}}</a><a class="jf-link" ng-if="row.entity.source_comp_id.split('://')[0] !== 'generic'">{{row.entity.source_comp_id.split('://')[1]}}</a></div>`,
                width: '20%'
            },
            {
                name: 'Infected Versions',
                displayName: 'Infected Versions',
                field: "infected_versions",
                cellTemplate: `<div ng-if="row.entity.component_versions.vulnerable_versions" class="ui-grid-cell-contents">{{row.entity.component_versions.vulnerable_versions.join(', ')}}</div><div ng-if="!row.entity.component_versions.vulnerable_versions" class="ui-grid-cell-contents">N/A</div>`,
                width: '10%'
            },
            {
                name: 'Fix Versions',
                displayName: 'Fix Versions',
                field: "fix_versions",
                cellTemplate: `<div ng-if="row.entity.component_versions.fixed_versions && row.entity.component_versions.fixed_versions.join(' ').indexOf('0.0.0') < 0"
				class="ui-grid-cell-contents">{{row.entity.component_versions.fixed_versions.join(', ')}}</div> <div ng-if="!row.entity.component_versions.fixed_versions || row.entity.component_versions.fixed_versions.join(' ').indexOf('0.0.0') > -1" class="ui-grid-cell-contents">N/A</div>`,
                width: '10%'
            }

        ]
    }

    _getUserIssuesGridColumn() {
        let _this = this;
        return [
            {
                name: 'Summary',
                displayName: 'Summary',
                field: 'summary',
                cellTemplate: `<div ng-click="grid.options.ctrl.ShowViolationModal(row.entity)" class="ui-grid-cell-contents"><a class="jf-link" >{{row.entity.summary}}</a></div>`,
                width: '25%'
            },
            {
                name: 'Severity',
                displayName: 'Severity',
                allowGrouping: true,
                cellTemplate: `<div ng-class="[row.entity.severity.toLowerCase()]" class="severity ui-grid-cell-contents">{{row.entity.severity}}</div>`,
                field: 'severity',
                width: '10%'
            },
            {
                name: 'Type',
                displayName: 'Type',
                cellTemplate: '<div class="ui-grid-cell-contents">{{row.entity.type | capitalizeFirst}}</div>',
                field: 'type',
                width: '10%'
            },
            {
                name: 'Watch Name',
                displayName: 'Watch Name',
                //cellTemplate: `<div  class="ui-grid-cell-contents"><a ui-sref="watchers.edit({watcherName:
                // row.entity.watcher_name})"> {{row.entity.watcher_name}} </a></div>`,
                field: 'watcher_name',
                allowGrouping: true,
                customActions: [{
                    icon: 'icon icon-arrow',
                    tooltip: 'View Watch',
                    callback: row => this.gotoWatch(row),
                    visibleWhen: (row) => row.watcher_name
                }],
                width: '15%'
            },
            {
                name: 'Targets',
                displayName: 'Violated Resources',
                //cellTemplate: `<div  class="ui-grid-cell-contents"><a ui-sref="watchers.edit({watcherName:
                // row.entity.watcher_name})"> {{row.entity.watcher_name}} </a></div>`,
                field: 'watcher_name',
                cellTemplate: '<div class="jf-link ui-grid-cell-contents" ><a ng-click="grid.options.ctrl.showResources(row.entity)" class="jf-link" >View Resources ({{row.entity.targets.length}})</a></div>',
                width: '15%'
            },
            {
                name: 'Component',
                displayName: 'Component',
                field: 'source',
                allowGrouping: true,
                cellTemplate: `<div ng-click="grid.options.ctrl.goToComp(row.entity.source_id,row.entity.source_version)" class="ui-grid-cell-contents"><a class="jf-link" >{{row.entity.source}}<span ng-if="row.entity.source_version">:{{row.entity.source_version}}</span></a></div>`,
                width: '20%'
            },
            {
                name: 'Created',
                displayName: 'Created',
                cellTemplate: '<div class="ui-grid-cell-contents">{{row.entity.updated | date:"medium"}}</div>',
                field: 'updated',
                width: '20%'
            },
            {
                name: 'policies',
                field: 'policies',
                displayName: 'Policies',
                cellTemplate: this.commonGridColumns.listableColumn('row.entity.policies', 'row.entity.summary', null, false),
                width: '15%',
                sortingAlgorithm: (a, b) => this.comparePolicy(a, b),
                customActions: [{
                    icon: 'icon icon-clear',
                    tooltip: 'Ignore Violation',
                    callback: (row) => {

                        this.ignoreUserIssue(row, row.type);
                    },
                    visibleWhen: (row) => row.permissions && row.permissions.manageable
                }]
            }
        ]
    }

    showResources(row) {
        console.log("need to show resources for", row);

        let modalScope = this.$scope.$new();

        this.tableViewOptions.setId('watch-targets-table')
            .setObjectName('Resource')
            .setColumns(this.getTargetsColumns())
            .setRowsPerPage(8)

        this.tableViewOptions.setData(row.targets);
        modalScope.modalTitle = `'${row.watcher_name}' Watch Resources `
        modalScope.tableOptions = this.tableViewOptions;

        this.modal.launchModal('show_list_grid_modal', modalScope).result.then(() => {
        });

    }

    getTargetsColumns() {

        return [
            {
                "header": "Type",
                "field": "type",
                'cellTemplate': `<div class="ui-grid-cell-contents" >{{row.entity.type | capitalizeFirst}}</div>`,
                "filterable": true
            },
            {
                "header": "Name",
                "field": "name",
                'cellTemplate': `<div class="ui-grid-cell-contents" >{{row.entity.name }}</div>`,
                "allowGrouping": true,
                "filterable": true
            },
            {
                "header": "Instance",
                'field': 'bin_mgr_id',
                'cellTemplate': `<div class="ui-grid-cell-contents" >{{row.entity.bin_mgr_id }}</div>`,
                "filterable": true
            }

        ]
    }


    goToComp(componentID, componentVersion) {
        console.log("Compid is", componentID);
        if (componentID) {
            this.$state.go('components.details', {componentID, componentVersion});
        }
    }

    comparePolicy(a, b) {
        let dir = _.find(this.userIssuesGridOptions.api.grid.columns, {field: 'policies'}).sort.direction;
        if (dir == 'asc') {
            if (a.length > b.length) {
                return 1;
            } else {
                return -1;
            }

        } else {
            if (a.length < b.length) {
                return -1;
            } else {
                return 1;
            }
        }


    }


    gotoWatch(row) {
        this.$state.go('watchers.edit', {watcherName: row.watcher_name});
    }

    getVersions(versions) {

        if (versions && versions.length > 0) {

            return versions[0].toString();
        }

        return '';

    }

    _getLicenseGridColumn() {
        return [
            {
                name: 'Name',
                displayName: 'Name',
                cellTemplate: `<div ng-class="row.entity.name.$value.toLowerCase()" class="ui-grid-cell-contents {{row.entity.name.$value}}">{{row.entity.name.$value}}<a ng-if="row.entity.name.$value.indexOf('Direct Licenses') < 0 && row.entity.name.$value.indexOf('Propagated Licenses') < 0 && (row.entity.name.$value.indexOf('Unknown') < 0 && row.entity.license_name.$value.indexOf('Unknown') < 0 ) "  ng-click="grid.options.ctrl.openInternalBrowser(row.entity.more_info.$value)" target="_blank"> (More Info)</a></div>`,
                field: "name",
                enableSorting: false,
                width: '40%'
            },
            {
                name: 'sources',
                displayName: 'Sources',
                //cellTemplate: `<div ng-if="grid.options.ctrl.isLink(row.entity.more_info.$value)"
                // class="ui-grid-cell-contents"><a  target="_blank"
                // href="{{row.entity.more_info.$value.trim()}}">{{row.entity.more_info.$value}}</a></div> <div
                // ng-if="!grid.options.ctrl.isLink(row.entity.more_info.$value)"
                // class="ui-grid-cell-contents">{{row.entity.more_info.$value}}</div>`
                enableSorting: false,
                field: 'sources',
                width: '60%'
            }]
    }

    openInternalBrowser(href) {

        let x = screen.width / 2 - 700 / 2 + this.findLeftWindowBoundry();
        let y = screen.height / 2 - 450 / 2 + this.findTopWindowBoundry();
        this.$window.open(href, 'XRAY', 'height=685,width=900,left=' + x + ',top=' + y);
        return false;

    }


    findLeftWindowBoundry() {
        // In Internet Explorer window.screenLeft is the window's left boundry
        if (this.$window.screenLeft) {
            return this.$window.screenLeft;
        }

        // In Firefox window.screenX is the window's left boundry
        if (this.$window.screenX) {
            return this.$window.screenX;
        }

        return 0;
    }

    // Find Left Boundry of current Window
    findTopWindowBoundry() {
        // In Internet Explorer window.screenLeft is the window's left boundry
        if (this.$window.screenTop) {
            return this.$window.screenTop;
        }

        // In Firefox window.screenY is the window's left boundry
        if (this.$window.screenY) {
            return this.$window.screenY;
        }

        return 0;
    }


    _getIssuesActions() {
        return [
            {
                icon: 'icon icon-artifactory-edit',
                tooltip: 'Edit Issue',
                callback: (row) => this.editIssue(row),
                visibleWhen: (row) => {
                    if (row.provider) {
                        return (this.XRayUIPermissions.isAdmin() || this.XRayUIPermissions.checkEdit(
                            'components')) && row.provider.toLowerCase() === 'custom';
                    }
                }

            },
            {
                icon: 'icon icon-clear',
                tooltip: 'Delete Issue',
                callback: (row) => this.deleteIssue(row),
                visibleWhen: (row) => {
                    if (row.provider && this.XRayUIPermissions.checkEdit('components')) {
                        return (this.XRayUIPermissions.isAdmin() || this.XRayUIPermissions.checkEdit(
                            'components')) && row.provider.toLowerCase() === 'custom';
                    }
                }

            }

        ];
    }

    _getLicensesActions() {
        return [

            /*	{
                    icon: 'icon icon-view',
                    tooltip: 'Read More',
                    callback: (row)=> {
                        window.open(row.more_info, '_blank');
                    },
                    visibleWhen: (row) => {
                        return row.more_info && row.more_info !== '';
                    }
                },*/
            {
                icon: 'icon icon-clear',
                tooltip: 'Delete License',
                callback: (row) => this.deleteLicense(row),
                visibleWhen: (row) => {
                    return row.is_custom && row.is_direct && this.manageable;
                }

            }
        ];
    }

    _getFilesGridColumn() {
        return [
            {
                name: 'Resource',
                displayName: 'Resource',
                field: 'target',
                cellTemplate: `<div class="ui-grid-cell-contents"><i ng-class="{'icon-local-repo':row.entity.target_type.toLowerCase() =='repository','icon-builds-new':row.entity.target_type.toLowerCase() =='build'}" class="icon"></i> {{row.entity.target}}</div>`,
                width: '30%'
            },
            {
                name: 'artifactory',
                displayName: 'Artifactory',
                field: 'instance_id',
                width: '40%'
            },
            {
                name: 'Occurrences',
                displayName: 'Occurrences',
                field: 'target_count',
                cellTemplate: `<div class="ui-grid-cell-contents">{{row.entity.target_count}}</div>`,
                width: '30%',
                customActions: [{
                    icon: 'icon icon-artifacts',
                    tooltip: 'More Info',
                    callback: (row) => this.showLocationsModal(row),
                    visibleWhen: (row) => {
                        return this.rootIsScannable
                    }
                }]
            }
        ]
    }


    deleteIssue(issue) {

        let qParams = {};
        qParams.pkg_type = this.xrayUtils.getPackagePrefix(
            this.$widgetObject.model.sharedData.compDetails.general_details.pkg_type).split('://')[0];
        qParams.component_id = this.$widgetObject.model.sharedData.compDetails.general_details.package_id.split(
            '://')[1] + this.versionOfComp;


        this.modal.confirm('Are you sure you want to delete this issue ?')
            .then(() => {
                this.eventXDao.deleteIssue(qParams, {vulnerabilityID: issue.id}).$promise.then(() => {

                    this.buildTabs({}, 'force');
                    this.jfrogEventBus.dispatch(this.EVENTS.CUSTOM_ISSUE_INJECTED);
                    this.refreshGrid();
                })
            });
    }

    deleteLicense(license) {
        this.modal.confirm('Are you sure you want to delete this license (' + license.name + ') ?')

            .then(() => {

                let ver = '';
                if (this.$widgetObject.model.sharedData.currentVersion) {
                    ver = ':' + this.$widgetObject.model.sharedData.currentVersion.version_number;
                }

                let params = {component_id: this.$stateParams.componentID + ver, license: license.license_name.$value};
                this.compLicensesDao.deleteLicense(params).$promise.then(() => {

                    this.buildTabs({}, 'force');
                    this.jfrogEventBus.dispatch(this.EVENTS.CUSTOM_ISSUE_INJECTED);
                    this.refreshGrid();
                });
            });
    }

    ignoreUserIssue(row, type) {
        this.IgnoreModal.launchForUserIssue(row).then((action) => {
            if (action.type === 'once') {
                this.ignoreWatchIssue(row, true, type, action.policies);
            }
            else if (action.type === 'permanently') {
                this.ignoreWatchIssue(row, false, type, action.policies, action.notes);

            }
        });

        this.buildTabs();
    }


    ignoreWatchIssue(row, once = true, type = 'security', policies, notes = "") {
        let ignore_once = once;
        let payload = {};
        payload.comp_id = this.$stateParams.componentID + this.versionOfComp;
        payload.watch_id = row.watcher_id;
        payload.policies = policies;
        payload.type = type;
        payload.issues = [row.issue_id];
        payload.target = row.target;
        payload.user_name = this.user.userName;

        if (notes !== "" && !ignore_once) {
            payload.notes = notes;
        }

        this.componentsDao.ignoreOnceUserWatchIssues({ignore_once}, payload).$promise.then((data) => {
            notes = "";

            if (this.userIssuesGridOptions && this.currentTab == 'violations') {
                this.userIssuesGridOptions.resetPagination();
            }


            this.buildTabs({}, 'force');

        });
    }

    ignoreAllViolations(ignore_once = true) {

        this.IgnoreModal.launchForUserIssue({}, "all").then((action) => {
            console.log("Procceding with ignore all", action);
            if (action.type === 'once') {
                ignore_once = true;
            }
            else if (action.type === 'permanently') {
                ignore_once = false;

            }

            let payload = {};
            payload.component_id = this.$stateParams.componentID + this.versionOfComp;
            console.log("Need to ignore all violations /ui/ignoreRules/ignoreAllIssues");
            this.componentsDao.ignoreAllUserWatchIssues({ignore_once}, payload).$promise.then((data) => {

                if (this.userIssuesGridOptions && this.currentTab == 'violations') {
                    this.userIssuesGridOptions.resetPagination();
                }


                this.buildTabs({}, 'force');

            });
        }).catch(() => {
            console.log("Action Aborted")
        });
    }

    editIssue(issue) {


        const assignCustomIssueModal = this.$scope.$new();
        assignCustomIssueModal.issueId = issue.id;
        assignCustomIssueModal.pkg_type = this.xrayUtils.getPackageByPrefix(issue.source_id.split("://")[0]).toLowerCase();
        assignCustomIssueModal.pkg_id = issue.source_id;
        let ver = this.xrayUtils.getVer(issue.source_id);
        assignCustomIssueModal.versionFilterOpt = [
            {
                type: 'current',
                displayName: ` Current Version (${ver.replace(':', '')})`,
                uiType: 'string',
                filterGroup: 'version',
                value: `${ver.replace(':', '')}`,
                isReadOnly: true
            },
            {
                type: 'specific',
                displayName: ` Specific Version`,
                uiType: 'string',
                filterGroup: 'version'
            },
            {type: 'range', displayName: 'Version Range', uiType: 'range', filterGroup: 'version'},
            {type: 'greater', displayName: 'Version Greater Than', uiType: 'string', filterGroup: 'version'},
            {
                type: 'greater-equal',
                displayName: 'Version Greater or Equal Than',
                uiType: 'string',
                filterGroup: 'version'
            },
            {type: 'lower', displayName: 'Version Lower Than', uiType: 'string', filterGroup: 'version'},
            {
                type: 'lower-equal',
                displayName: 'Version Lower or Equal Than',
                uiType: 'string',
                filterGroup: 'version'
            }, {
                type: 'all',
                displayName: `All Versions`,
                uiType: 'string',
                value: 'All Versions',
                filterGroup: 'version',
                isReadOnly: true
            }

        ];

        assignCustomIssueModal.componentId = issue.source_comp_id;

        this.modal.launchModalWithTemplateMarkup(require('../../modal_templates/assign_custom_issue_modal.html'), assignCustomIssueModal).result.then(() => {
            this.buildTabs({}, 'force');
        })
    }

    assignCustomIssue(componentID) {
        const assignCustomIssueModal = this.$scope.$new();
        let noColonVer = "";
        let ver = "";
        if (!componentID || (componentID && componentID.component_id == this.$widgetObject.model.sharedData.compDetails.general_details.package_id)) {
            if (this.$widgetObject.model.sharedData.currentVersion) {
                ver = ':' + this.$widgetObject.model.sharedData.currentVersion.version_number;
                noColonVer = this.$widgetObject.model.sharedData.currentVersion.version_number;
            }
            ver = this.versionOfComp;

            assignCustomIssueModal.pkg_type = this.getPkgName(
                this.$widgetObject.model.sharedData.compDetails.general_details.pkg_type);
            assignCustomIssueModal.pkg_id = this.$widgetObject.model.sharedData.compDetails.general_details.package_id;

        } else {
            ver = this.getVer(componentID.component_id);
            assignCustomIssueModal.pkg_id = this.cleanVer(componentID.component_id);
            if (componentID.pkg_type) {
                assignCustomIssueModal.pkg_type = componentID.pkg_type.toLowerCase();
            }
        }


        if (ver !== '') {
            if (!componentID) {
                assignCustomIssueModal.internalVersions = this.$widgetObject.model.sharedData.currentInternalVersions;
            } else {
                let tmpArr = [];
                tmpArr.push(ver.toString());
                assignCustomIssueModal.internalVersions = tmpArr;
            }
            assignCustomIssueModal.versionFilterOpt = [
                {
                    type: 'current',
                    displayName: ` Current Version (${ver.replace(':', '')})`,
                    uiType: 'string',
                    filterGroup: 'version',
                    value: `${ver.replace(':', '')}`,
                    isReadOnly: true
                },
                {
                    type: 'specific',
                    displayName: ` Specific Version`,
                    uiType: 'string',
                    filterGroup: 'version'
                },
                {type: 'range', displayName: 'Version Range', uiType: 'range', filterGroup: 'version'},
                {type: 'greater', displayName: 'Version Greater Than', uiType: 'string', filterGroup: 'version'},
                {
                    type: 'greater-equal',
                    displayName: 'Version Greater or Equal Than',
                    uiType: 'string',
                    filterGroup: 'version'
                },
                {type: 'lower', displayName: 'Version Lower Than', uiType: 'string', filterGroup: 'version'},
                {
                    type: 'lower-equal',
                    displayName: 'Version Lower or Equal Than',
                    uiType: 'string',
                    filterGroup: 'version'
                },
                {
                    type: 'all',
                    displayName: `All Versions`,
                    uiType: 'string',
                    value: 'All Versions',
                    filterGroup: 'version',
                    isReadOnly: true
                }];
        }

        if ((componentID && this.$widgetObject.model.sharedData.compDetails.general_details.package_id) && componentID.toString() == this.$widgetObject.model.sharedData.compDetails.general_details.package_id.toString()) {

            assignCustomIssueModal.componentId = componentID + ver || this.$widgetObject.model.sharedData.compDetails.general_details.package_id + ver;
            this.modal.launchModalWithTemplateMarkup(require('../../modal_templates/assign_custom_issue_modal.html'), assignCustomIssueModal).result.then(() => {

            })

        } else if (!componentID) {

            assignCustomIssueModal.componentId = this.$widgetObject.model.sharedData.compDetails.general_details.package_id + ver;
            this.modal.launchModalWithTemplateMarkup(require('../../modal_templates/assign_custom_issue_modal.html'), assignCustomIssueModal).result.then(() => {

            })
        } else {
            assignCustomIssueModal.componentId = componentID.component_id;
            this.modal.launchModalWithTemplateMarkup(require('../../modal_templates/assign_custom_issue_modal.html'), assignCustomIssueModal).result.then(() => {

            })
        }

        //COMPONENT_DATA_UPDATED
    }

    getPkgName(pkg) {

        if (pkg == 'deb') {
            return 'debian';
        }
        return pkg;
    }

    itemClicked($index, ctrl) {

        ctrl.selectedIndex = $index;

    }

    ShowViolationModal(row) {
        let currentCompId = this.$widgetObject.model.sharedData.compDetails.general_details.package_id;
        let version = '';
        if (this.$widgetObject.model.sharedData.compDetails.general_details.type !== 'File' && !this.$widgetObject.model.sharedData.compDetails.general_details.hide_versions_menu && this.$widgetObject.model.sharedData.currentVersion) {
            version = ':' + this.$widgetObject.model.sharedData.currentVersion.version_number;
        }

        let issueModalData = this.$scope.$new();
        issueModalData.itemClicked = this.itemClicked;
        issueModalData.ctrl = this;
        issueModalData.wideMode = false;
        issueModalData.selectedIndex = this.selectedIndex;
        issueModalData.infected_comp = row.comp_id;
        issueModalData.paths = row.paths;

        let paramPayload = {};
        paramPayload.type = row.type;
        paramPayload.$no_spinner = true;

        let violatioRow = _.cloneDeep(row);
        delete violatioRow.watcher_id;
        delete violatioRow.paths;

        delete violatioRow.permissions;
        if (violatioRow.watcher_name) {
            violatioRow.watch_name = violatioRow.watcher_name;
            delete  violatioRow.watcher_name;
        }
        violatioRow.watch_target = violatioRow.target;


        delete violatioRow.target;
        delete violatioRow.watcher_name;
        violatioRow.type = this.$filter('capitalizeFirst')(violatioRow.type);
        if (violatioRow.fix_versions) {
            violatioRow.fixed_versions = violatioRow.fix_versions;
            delete  violatioRow.fix_versions;
        }
        if (violatioRow.source_id) {
            delete  violatioRow.source_id;
        }
        if (violatioRow.source) {
            violatioRow.infected_component = violatioRow.source;
            delete  violatioRow.source_id;
        }

        if (violatioRow.comp_id) {
            delete violatioRow.comp_id;
        }


        let package_type = '';
        if (violatioRow.source_id && violatioRow.source_id.indexOf('://') > -1) {
            violatioRow.package_type = this.xrayUtils.getPackageByPrefix(violatioRow.source_id.split('://')[0]);
            violatioRow.source_id = violatioRow.source_id.split('://')[1];

        }


        issueModalData.isViolation = true;
        issueModalData.details = violatioRow;
        if (violatioRow.type && violatioRow.type.toLowerCase() == 'security') {
            let issuePayload = {};
            issuePayload.vulnerability_id = row.issue_id;
            issuePayload.source_name = row.source;
            issuePayload.component_id = currentCompId + version;
            this.componentsDao.getComponentIssues(paramPayload, issuePayload).$promise.then((alert) => {

                if (alert.cves) {
                    if (!alert.cves[0].cve) {
                        delete alert.cves;
                    } else {
                        issueModalData.details.cves = alert.cves;
                    }

                }

                if (alert.references) {
                    issueModalData.details.references = alert.references;
                }

                if(alert.provider){
                    issueModalData.details.provider = alert.provider;
                }


                this.eventxDao.getImpactGraph(paramPayload, {
                    component_id: currentCompId + version,
                    vulnerability_id: row.issue_id
                }).$promise.then((graph) => {
                    delete issueModalData.details.issue_id;
                    this.selectedIndex = 0;
                    issueModalData.graph = graph;
                    issueModalData.graph.component_id = this.xrayUtils.getComponentPrettyName(graph.component_id);
                    this.infectionGraph = graph.impact_paths;
                    if (graph.impact_paths.length == 0) {
                        issueModalData.wideMode = true;
                    }
                    issueModalData.details = this.orderDetailsObj(issueModalData.details);
                    this.modal.launchModalWithTemplateMarkup(require('../../modal_templates/issue_modal.html'), issueModalData).result.then(() => {

                    });
                });

            });
        } else {
            issueModalData.details.policies = row.matched_policies
            this.eventxDao.getImpactGraph(paramPayload, {
                component_id: currentCompId + version,
                vulnerability_id: row.issue_id
            }).$promise.then((graph) => {
                delete issueModalData.details.issue_id;
                this.selectedIndex = 0;
                issueModalData.graph = graph;
                issueModalData.graph.component_id = this.xrayUtils.getComponentPrettyName(graph.component_id);
                this.infectionGraph = graph.impact_paths;
                if (graph.impact_paths.length == 0) {
                    issueModalData.wideMode = true;
                }
                issueModalData.details = this.orderDetailsObj(issueModalData.details);
                this.modal.launchModalWithTemplateMarkup(require('../../modal_templates/issue_modal.html'), issueModalData).result.then(() => {

                });
            });

        }


    }

    orderDetailsObj(detailsObj) {

        console.log('details : ', detailsObj);
        let tmpObj = _.cloneDeep(detailsObj);
        let finaObj = {};

        finaObj = {
            summary: tmpObj.summary,
            description: tmpObj.description,
            type: tmpObj.type,
            provider: tmpObj.provider,
            severity: tmpObj.severity,
            update: tmpObj.updated,
            cves: tmpObj.cves,
            package_type: tmpObj.package_type,
            references: tmpObj.references,
            infected_component: tmpObj.infected_component,
            source_version: tmpObj.source_version,
            infected_versions: tmpObj.infected_versions,
            fixed_versions: tmpObj.fixed_versions,
            watch_target: tmpObj.watch_target,
            watch_name: tmpObj.watch_name,
            matched_policies: tmpObj.policies
        }


        return _.omit(finaObj, _.isEmpty);
    }

    ShowIssueModal(id, source, caller = 'issue', entitiy = {}) {
        const issueModalData = this.$scope.$new();
        issueModalData.itemClicked = this.itemClicked;
        issueModalData.ctrl = this;
        issueModalData.showAllFixedVersions = false;
        issueModalData.wideMode = false;
        issueModalData.selectedIndex = this.selectedIndex;
        issueModalData.infected_comp = source;

        this.getAlert(id, source, issueModalData, caller, entitiy);

    }

    getAlert(id, sourceName, modalScope, caller, entitiy) {

        let currentCompId = this.$widgetObject.model.sharedData.compDetails.general_details.package_id;
        let version = "";
        if (this.$widgetObject.model.sharedData.compDetails.general_details.type !== 'File' && !this.$widgetObject.model.sharedData.compDetails.general_details.hide_versions_menu && this.$widgetObject.model.sharedData.currentVersion) {
            version = ":" + this.$widgetObject.model.sharedData.currentVersion.version_number;
        }
        let source_name = sourceName;
        let vulnerability_id = id;
        let component_id = currentCompId + version;
        let source_comp_id = entitiy.source_comp_id;
        let paramPayload = {$no_spinner: true};
        if (caller == 'license') {
            paramPayload.type = 'license';
        }

        this.componentsDao.getComponentIssues(paramPayload, {
            source_name,
            vulnerability_id,
            component_id,
            source_comp_id
        }).$promise.then((alert) => {

            this.alertData = alert;
            this.title = 'Alert Details for Watch \'' + this.alertData.watch_name + '\'';
            //this.alertData.displayEventType = _.capitalize(this.alertData.event_type || 'other');

            if (alert.versions) {
                if (alert.versions.fixed_versions) {

                    alert.fixed_versions = alert.versions.fixed_versions;
                }
                alert.versions = alert.versions.vulnerable_versions;
            }

            if (alert.cves) {
                if (!alert.cves[0].cve) {
                    delete alert.cves;
                }
            }

            if (alert.component_id) {

                modalScope.comp_id = this.xrayUtils.getComponentPrettyName(alert.component_id);
                delete alert.component_id;
            }
            delete alert.vulnerability_id;
            if (alert.versions) {
                if (alert.versions[0] == '') {
                    delete alert.versions;
                }
            }

            if (alert.properties) {
                if (alert.properties.bugs) {
                    alert.bugs = alert.properties.bugs;
                }

                if (alert.properties.patches_comments) {
                    alert.fix_patches = alert.properties.patches_comments;
                }
                delete alert.properties;
            }
            if (alert.description == alert.summary) {
                delete alert.description;
            }

            if (alert.type) {
                alert.type = this.$filter('capitalizeFirst')(alert.type);
            }
            if (alert.package_type) {
                alert.package_type = this.$filter('capitalizeFirst')(alert.package_type);
            }


            if (alert.sources) {

                let filtered = _.filter(alert.sources, (s) => {
                    if (s.name) {
                        return s.name.toLowerCase().indexOf('snyk') > -1;
                    }
                    return false;
                });
                if (filtered.length) {
                    alert.source = filtered[0];
                    if (alert.source.url) {

                        let xrayCampaignSign = '?utm_source=jfrog&utm_medium=partners&utm_campaign=xray';
                        alert.source.url = `${alert.source.url}${xrayCampaignSign}`;
                    }

                }
                delete alert.sources;
            }
            modalScope.details = alert;

        })

        this.launchModal(paramPayload, currentCompId, version, id, modalScope);
    }


    launchModal(paramPayload, currentCompId, version, id, modalScope) {

        this.eventxDao.getImpactGraph(paramPayload, {
            component_id: currentCompId + version,
            vulnerability_id: id
        }).$promise.then((graph) => {

            this.selectedIndex = 0;
            modalScope.graph = graph;
            modalScope.graph.component_id = this.xrayUtils.getComponentPrettyName(graph.component_id);
            this.infectionGraph = graph.impact_paths;
            if (graph.impact_paths && !graph.impact_paths.length) {
                modalScope.wideMode = true;
            }
            this.modal.launchModalWithTemplateMarkup(require('../../modal_templates/issue_modal.html'), modalScope).result.then(() => {

            });
        });
    }

    isArray(o) {
        return _.isArray(o);
    }

    isLink(str) {
        if (typeof str != 'string' || !str) {
            return false;
        }
        str = str.trim();
        return str && str.startsWith('http://') || str.startsWith('https://') || str.startsWith('www.');
    }


    _getActions() {
        return {
            'seeRelatedComponents': {title: 'View Component Details', icon: 'icon-view'},
            'manualScan': {title: 'Scan for Violations', icon: 'icon-xray-scanning'},
            'assignCustomIssue': {title: 'Assign Custom Issue', icon: 'icon-xray-impact-analysis'},
            'assignCustomLicense': {title: 'Assign Custom License', icon: 'icon-report'},
            'downloadPDF': {title: 'Download PDF', icon: 'icon-pdf'},
            'exportData': {title: 'Export Data', icon: 'icon-upload'},
        }
    }

    initActions(actionsController) {


        actionsController.setActionsDictionary(this._getActions());
        this.$timeout(() => {
            let root = this.$stateParams.componentID;
            if (this.$widgetObject.model.sharedData.compDetails) {
                if (this.$widgetObject.model.sharedData.compDetails.general_details) {
                    root = this.$widgetObject.model.sharedData.compDetails.general_details.package_id
                }
            }

            /*

             {
                    name: 'downloadPDF',
                    visibleWhen: () => true,
                    action: () => this.downloadPDF()
                },

             */

            actionsController.setActions([
                {
                    name: 'seeRelatedComponents',
                    visibleWhen: () => this.currComponentId !== this.rootComponentId,
                    action: () => this.seeRelatedComponents()
                },
                {
                    name: 'manualScan',
                    visibleWhen: () => this.currComponentId !== this.rootComponentId ? this.currNode && this.currNode.is_root : this.rootIsScannable,
                    action: () => this.manualScan()
                },
                {
                    name: 'assignCustomIssue',
                    visibleWhen: () => true,
                    action: () => this.assignCustomIssue()
                },
                {
                    name: 'assignCustomLicense',
                    visibleWhen: () => true,
                    action: () => this.assignCustomLicense()
                },
                {
                    name: 'exportData',
                    visibleWhen: () => this.currComponentId !== this.rootComponentId ? this.currNode && this.currNode.is_root : this.rootIsScannable,
                    action: () => this.exportData()
                }
            ]);

        }, 500);

    }


    manualScan(componentID) {

        let comp = "";
        let ver = "";

        ver = this.versionOfComp;

        if (!componentID) {
            comp = this.$stateParams.componentID + ver;
        } else {
            if (this.$stateParams.componentID == componentID) {
                comp = componentID + ver;
            } else {
                comp = componentID;
            }
        }
        this.scanDao.startScan({componentID: comp}).$promise.then((result) => {
            if (result.info) {
                this.jFrogNotifications.create({info: 'Manual Scan Started'});
            }
        });
    }

    getDetails() {
        let pkg_id = this.$widgetObject.model.sharedData.compDetails.general_details.package_id
        this.componentsDao.getDetails({}, {
            component_id: pkg_id
        }).$promise.then((details) => {
            this.$widgetObject.model.sharedData.compDetails = details.data;
            this.buildTabs(details.data);
        });
    }


    seeRelatedComponents(componentID) {

        let componentVersion = this.getVer(componentID);
        componentID = this.cleanVer(componentID);

        this.$state.go('components.details', {componentID, componentVersion});
    }

    /** Handle Version extraction **/

    cleanVer(str) {
        return this.xrayUtils.cleanVer(str);
    }

    getVer(str) {
        return this.xrayUtils.getVer(str);
    }

    /** End Handle Version extraction **/
    getNomalizedKey(key) {

        if (key.toLowerCase() == 'cves') {
            return 'CVEs';
        }
        return _.startCase(key);
    }


    getIssues(force = true, pagination) {

        let promise = '';
        if (!this.fetchIssuesInProgress) {
            this.fetchIssuesInProgress = true;
            if (this.issuesGridOptions) {
                this.issuesGridOptions.ctrl = this;
            }
            if (this.userIssuesGridOptions) {
                this.userIssuesGridOptions.ctrl = this;
            }
            pagination = pagination || this.defaultPagination;
            let payload = {};

            if (this.$widgetObject.model.sharedData.currentVersion) {
                if (this.$widgetObject.model.sharedData.currentVersion.version_number) {
                    payload.version = this.$widgetObject.model.sharedData.currentVersion.version_number;
                }
            }

            payload.package_id = this.$stateParams.componentID;

            if (this.issueQuery !== '') {

                payload.key = this.issueQuery;
            } else {
                delete payload.key;
            }

            if (force) {
                promise = this.componentsDao.getIssuesPaginated(pagination, payload).$promise;


                promise.then((results) => {
                    console.log("Fetched security issues", results);
                    if (results.data) {
                        if (results.data.length > 0) {

                            //this.issuesGridOptions.setGridData(results.data)
                            this.hasIssues = true;
                        } else {
                            this.hasIssues = false;
                        }
                    } else {
                        this.hasIssues = false;
                    }

                    this.fetchIssuesInProgress = false;
                });

            } else {

                pagination = pagination || this.defaultPagination;
                //TODO: Return the statement to permission check mode (this.XRayUIPermissions.checkView('alerts') instead of hardcoded "true")
                if (true) {
                    promise = this.componentsDao.getUserWatchIssuesPaginated(pagination, payload).$promise.then(
                        (results) => {
                            // setting count watched obj
                            this.countWatchViolation = {};
                            _.each(_.map(_.uniq(results.data, 'watcher_name'), 'watcher_name'), (n) => {
                                this.countWatchViolation[n] = 0;
                            });
                            _.each(this.countWatchViolation, (val, key) => {
                                this.countWatchViolation[key] = _.filter(results.data, (n) => {
                                    return n.watcher_name == key;
                                }).length;
                            });

                            _.each(results.data, (val, key) => {
                                val.policies = _.map(val.matched_policies, 'policy')
                            })


                            this.userIssuesGridOptions.setGridData(
                                _.sortBy(results.data, ['updated', 'watcher_name', 'issue_id']));
                            this.fetchIssuesInProgress = false;

                        });
                } else {
                    //console.log('Cannot view violations due to permission level')
                    this.fetchIssuesInProgress = false;
                }

            }
        }
        if (promise == '') {
            promise = {};
            promise.then = () => {
            };
        }
        return promise;
    }

    getUserLicensesIssues(pagination) {

        if (this.userLicensesIssuesGridOptions) {
            this.userLicensesIssuesGridOptions.ctrl = this;
        }

        pagination = pagination || this.defaultLicensesPagination;

        pagination.type = 'license';
        let payload = {};
        let promise = '';
        if (this.$widgetObject.model.sharedData.currentVersion) {
            if (this.$widgetObject.model.sharedData.currentVersion.version_number) {
                payload.version = this.$widgetObject.model.sharedData.currentVersion.version_number;
            }
        }

        payload.package_id = this.$stateParams.componentID;

        if (this.issueQuery !== '') {

            payload.key = this.issueQuery;
        } else {
            delete payload.key;
        }

        promise = this.componentsDao.getUserWatchLicensesIssuesPaginated(pagination, payload).$promise;

        promise.then((results) => {

        });
        return promise;
    }

    refreshGrid() {
        if (this.issuesGridOptions && this.issuesGridOptions.api && this.currentTab == 'issues') {
            this.issuesGridOptions.resetPagination();
        }
        if (this.userIssuesGridOptions && this.userIssuesGridOptions.api && this.currentTab == 'violations') {
            this.userIssuesGridOptions.resetPagination();
            this.getIssues(false);
        }
        if (this.currentTab == 'licenses') {

            this.$timeout(() => {
                this.showAboutBox = false;
                console.log("hiding about box");

            }, 300)
            this.$timeout(() => {
                this.showAboutBox = true;
                console.log("showing about box");

            }, 300)

        }

    }

    getLicenses(force = false) {
        let payload = {};

        if (this.$widgetObject.model.sharedData.currentVersion) {
            if (this.$widgetObject.model.sharedData.currentVersion.version_number) {
                payload.version = this.$widgetObject.model.sharedData.currentVersion.version_number;
            }
        }

        payload.package_id = this.$stateParams.componentID;

        if (!this.licenses || force) {

            this.componentsDao.getLicense({$no_spinner: true}, payload).$promise.then((data) => {

                if (!_.isEmpty(data.licenses)) {
                    this.licenses = data.licenses;

                    let directLicense = _.filter(data.licenses, (n) => {
                        return n.is_direct;
                    });
                    let propagatedLicenses = _.filter(data.licenses, (n) => {
                        return !n.is_direct;
                    });
                    let newData = [{
                        name: 'Direct Licenses (' + directLicense.length + ')',
                        $expanded: directLicense.length > 0
                    },
                        {
                            name: 'Propagated Licenses (' + propagatedLicenses.length + ')',
                            $expanded: propagatedLicenses.length > 0
                        }];
                    newData[0].$subRows = directLicense;
                    newData[1].$subRows = propagatedLicenses;

                    _.map(newData, (parent) => {
                        _.map(parent.$subRows, (row) => {
                            row.more_info = row.more_info[0];
                            row.sources = _.map(row.sources, 'source').join(', ');
                        });
                    });
                    this.licenses = newData;
                    this.licenseGridOptions.setGridData(newData);
                    this.licenseGridOptions.ctrl = this;
                    this.hasLicenses = true;
                    this.hasLiceCount = true;
                } else {
                    this.hasLicenses = false;
                    this.hasLiceCount = false;
                }
            });
        } else {
            this.licenseGridOptions.setGridData(this.licenses);
        }


    }

    setDebounceMethod() {
        this.filterIssue = _.debounce((e) => {
            this.refreshGrid();
        }, 300);
    }

    getLocations(force = false) {
        let payload = {};
        if (this.$widgetObject.model.sharedData.currentVersion) {
            if (this.$widgetObject.model.sharedData.currentVersion.version_number) {
                payload.version = this.$widgetObject.model.sharedData.currentVersion.version_number;
            }
        }

        payload.package_id = this.$stateParams.componentID;

        if (!this.locations || force) {
            this.componentsDao.getFiles({$no_spinner: true}, payload).$promise.then((data) => {
                if (data.length > 0) {

                    this.locations = data.files;
                    this.filesGridOptions.setGridData(data);
                    this.filesGridOptions.ctrl = this;
                    this.hasLocations = true;
                } else {
                    this.hasLocations = false;
                }
            });
        } else {
            this.filesGridOptions.setGridData(this.locations);

        }

    }

    showLocationsModal(row) {
        let payload = {};
        payload.resource = _.pick(row, ['target', 'instance_id', 'target_count', 'target_type']);
        payload.component_id = this.$widgetObject.model.sharedData.compDetails.general_details.package_id + this.versionOfComp;

        let modalScope = this.$scope.$new();
        modalScope.compId = this.xrayUtils.getComponentPrettyName(payload.component_id);
        modalScope.repo = payload.resource.target;
        modalScope.instance = payload.resource.instance_id;


        modalScope.data = row.comp_more_details;
        modalScope.gridOptions = this.jfrogGridFactory.getGridInstance(this.$scope)
            .setRowTemplate('default')
            .setColumns(this._getLocationsModalColumns())
            .setGridData(row.comp_more_details);

        let options = {windowClass: 'files-modal'};

        this.modal.launchModal('show_locations_modal', modalScope, 'lg', true, options).result.then(() => {

        });

    }

    toggleVersionsWidget() {
        this.showVersions = this.showVersions == true ? false : true;
        let width;
        if (this.showVersions) {
            width = 25;
        } else {
            width = 0;
        }

        this.$timeout(() => {

            $($('.widget-wrapper.ng-scope.widget-wrapper-')[4]).css('left', width + '%');
            setTimeout(() => {

                this.issuesGridOptions.refreshColumns();
                this.licenseGridOptions.refreshColumns();
                this.filesGridOptions.refreshColumns();
                this.userIssuesGridOptions.refreshColumns();
                this.$scope.$apply();
            }, 500);
        });

    }

    _getLocationsModalColumns() {
        return [
            {
                name: 'Name',
                displayName: 'File Name',
                cellTemplate: `<div class="ui-grid-cell-contents"><a ng-href="{{row.entity.link}}" target="_blank">{{row.entity.file_name}}</a></div>`,
                field: 'file_name',
                sort: {
                    direction: this.uiGridConstants.ASC
                },
                width: '50%'
            }, {
                name: 'sha',
                displayName: 'SHA-256',
                field: 'sha256',
                width: '50%'
            }];
    }


    assignCustomLicense(componentID, origin = '') {

        /*

        	PackageId string `json:"package_id"`
	CompName  string `json:"component_name"`
	PkgType   string `json:"pkg_type"`
	Version   string `json:"version"`
         */
        let defer = this.$q.defer();
        const assignCustomIssueModal = this.$scope.$new();
        assignCustomIssueModal.ctrl = this;
        let tmpObj = {package_id: '', pkg_type: '', version: ''};
        let noColonVer = '';
        let ver = '';
        let options = {windowClass: 'set-license-modal'};
        if (origin == 'tree') {
            tmpObj.version = this.xrayUtils.getVer(componentID.component_id);
            if (componentID.pkg_type) {
                tmpObj.pkg_type = componentID.pkg_type.toLowerCase();
            }
            tmpObj.package_id = this.xrayUtils.cleanVer(componentID.component_id);
            tmpObj.component_name = this.xrayUtils.getComponentPrettyName(componentID.component_id);

        } else if (origin == 'aboutbox') {
            tmpObj.version = componentID.version;
            if (componentID.pkg_type) {
                tmpObj.pkg_type = componentID.pkg_type.toLowerCase();
            }
            tmpObj.package_id = componentID.package_id;
            tmpObj.component_name = componentID.component_name;

        }
        else if (origin == 'aboutbox-bulk') {
            tmpObj = componentID;
            assignCustomIssueModal.type = 'bulk';
        } else if (origin == 'aboutbox-view') {
            assignCustomIssueModal.type = 'view';
            tmpObj = componentID;
        }
        else {
            if (this.$widgetObject.model.sharedData.currentVersion) {
                noColonVer = this.$widgetObject.model.sharedData.currentVersion.version_number;
                ver = ':' + this.$widgetObject.model.sharedData.currentVersion.version_number;
                tmpObj.version = this.$widgetObject.model.sharedData.currentVersion.version_number;
            }

            ver = this.versionOfComp;
            tmpObj.pkg_type = this.$widgetObject.model.sharedData.compDetails.general_details.pkg_type;
            tmpObj.package_id = this.$widgetObject.model.sharedData.compDetails.general_details.package_id;
            tmpObj.component_name = this.$widgetObject.model.sharedData.compDetails.general_details.package_name;

        }
        if ((componentID && this.$widgetObject.model.sharedData.compDetails.general_details.package_id) && componentID.toString() == this.$widgetObject.model.sharedData.compDetails.general_details.package_id.toString()) {

            assignCustomIssueModal.componentId = componentID + ver || this.$widgetObject.model.sharedData.compDetails.general_details.package_id + ver;
            this.modal.launchModal('assign_custom_license_modal', assignCustomIssueModal, 'lg', true, options)
                .result
                .then(() => {
                });

        } else if (!componentID) {
            assignCustomIssueModal.componentId = this.$widgetObject.model.sharedData.compDetails.general_details.package_id + ver;
            this.modal.launchModal('assign_custom_license_modal', assignCustomIssueModal, 'lg', true, options)
                .result
                .then(() => {
                });
        } else {
            assignCustomIssueModal.componentId = componentID;
            assignCustomIssueModal.propagatedLicense = {};

            this.modal.launchModal('assign_custom_license_modal', assignCustomIssueModal, 'lg', true, options)
                .result
                .then(() => {
                    defer.resolve(assignCustomIssueModal.compDetails.newAssignedLicense);
                });
        }
        assignCustomIssueModal.compDetails = tmpObj;
        return defer.promise;
    }

    setTabAfterRebuild(tabName) {
        this.currentTab = tabName;
        this.onChangeTab({name: tabName});
        let className = '.nav-tabs .' + tabName;

        let obj = $(className);

        obj.siblings().removeClass('active');
        obj.addClass('active');
    }

    setClickEventListener() {
        let _self = this;
        //$(document).off();
        this.$timeout(() => {

            $(document).on('click', 'ul.nav.nav-tabs li', function () {
                let name = $(this).find('span').text().split(' ')[0];
                _self.setLastVisitedTab(name);
            });

            $(document).on('keyup', function (e) {
                if (e.keyCode === 27) { // ESC
                    if ($('.vakata-context').length > 0) {
                        $('.vakata-context').hide();
                    }

                }
            });

            $(document).on('click', function (e) {
                if ($(e.target).closest($('.vakata-context')).length === 0) {
                    $('.vakata-context').hide();
                }
            });
        });

    }

    setLastVisitedTab(name) {
        this.XRayUIState.setState('lastTabClicked', name.toLowerCase());
    }


    getLastVisitedTab() {
        return this.XRayUIState.getState('lastTabClicked');
    }


    clickTab(tab) {

        this.$timeout(() => {
            if (!tab) {

                if ($('.violations').length) {
                    tab = 'violations';
                } else {
                    tab = 'issues';
                }
                $('.nav-tabs .' + tab + ' a').click();
                //return
            }
            if (tab == 'security') {
                tab = 'issues';
            }
            if (this.currentTab !== tab) {
                $('.' + tab + ' a').click();
            }

            this.refreshGrid();
        }, 500)
    }

    showAboutBox() {
        console.log("Need to show about box for component_id:", this.$widgetObject.model.sharedData.compDetails.general_details.package_id);

        let ver = '';
        if (this.$widgetObject.model.sharedData.currentVersion) {
            ver = ':' + this.$widgetObject.model.sharedData.currentVersion.version_number;
        }
        let modalScope = this.$scope.$new();
        modalScope.componentId = this.$stateParams.componentID + ver;
        let options = {windowClass: 'aboutbox-modal'};
        this.modal.launchModal('show_about_box_modal', modalScope, 'lg', true, options).result.then((response) => {
            console.log("About box closed");
        });

    }

    getCurrentCompId() {
        let ver = '';
        if (this.$widgetObject.model.sharedData.currentVersion) {
            ver = ':' + this.$widgetObject.model.sharedData.currentVersion.version_number;
        }

        return this.$stateParams.componentID + ver;

    }

    setArrayObjUnique(arrayOfObj) {
        _.map(
            _.uniq(
                _.map(arrayOfObj, (obj) => {
                    return JSON.stringify(obj);
                })
            ), (obj) => {
                return JSON.parse(obj);
            }
        );
    }


    exportData() {
        let modalScope = this.$scope.$new();
        let options = {windowClass: 'aboutbox-modal'};
        this.modal.launchModal('export_data_modal', modalScope, 'lg', true, options).result.then((response) => {


        });
    }

    downloadExportData(formatType) {
        let keys = _.keys(this.dataToExport, (val, key) => {
            return val
        });
        let finalArr = [];
        _.forEach(keys, (val) => {

            if (this.dataToExport[val]) {
                let type = val + '=true'
                finalArr.push(type)
            }
        })

        let dataToExport = finalArr.join('&')

        console.log('key is ', keys)
        console.log('need to download', dataToExport);
        console.log('in type', formatType);

        let qParams;
        let token = this.user.token;
        let url = '/ui/component/exportComponentDetails?token='
        let exclude_unknown = "";
        if (this.dataToExport.license) {
            if (this.excludeUnknown) {
                exclude_unknown = '&exclude_unknown=true'
            } else {
                exclude_unknown = '&exclude_unknown=false'
            }

        }
        if (this.getFullCompId().split('://')[0] == 'generic') {

            qParams = {
                compName: this.getFullCompId().split('//')[1].split('/')[1],
                prefix: 'generic',
                sha: this.getFullCompId().split('//')[1].split('/')[0]
            }
            qParams.format = formatType;

            this.$window.open(url + token + '&prefix=generic&sha=' + qParams.sha + '&comp_name=' + qParams.compName + '&format=' + qParams.format + '&' + dataToExport + exclude_unknown, "_self");

        } else {
            qParams = {
                compName: this.getFullCompId().split('://')[1],
                prefix: this.getFullCompId().split('://')[0]
            }
            qParams.format = formatType;

            this.$window.open(url + token + '&prefix=' + qParams.prefix + '&comp_name=' + qParams.compName + '&format=' + qParams.format + '&' + dataToExport + exclude_unknown, "_self");

        }
    }

    exportLicense() {
        if (!this.dataToExport.license) {
            this.excludeUnknown = false;
        }
    }

    downloadPDF() {
        let columns = ["Severity", "Type", "Watch Name", "Violated Resources", "Summary"];
        let rows = [
            [
                "Medium",
                "license",
                "WatcherOsher",
                "generic-local",
                "Atlassian End User License Agreement 3.0"
            ],
            [
                "Medium",
                "security",
                "WatcherOsher",
                "generic-local",
                "In the Bouncy Castle JCE Provider version 1.55 and earlier the primary engine class used for AES was AESFastEngine. Due to the highly table driven approach used in the algorithm it turns out that if the data channel on the CPU can be monitored the lookup table accesses are sufficient to leak information on the AES key being used. There was also a leak in AESEngine although it was substantially less. AESEngine has been modified to remove any signs of leakage (testing carried out on Intel X86-64) and is now the primary AES class for the BC JCE provider from 1.56. Use of AESFastEngine is now only recommended where otherwise deemed appropriate."
            ],
            [
                "Medium",
                "security",
                "WatcherOsher",
                "generic-local",
                "In the Bouncy Castle JCE Provider version 1.55 and earlier DSA signature generation is vulnerable to timing attack. Where timings can be closely observed for the generation of signatures, the lack of blinding in 1.55, or earlier, may allow an attacker to gain information about the signature's k value and ultimately the private value as well."
            ],
            [
                "Medium",
                "security",
                "WatcherOsher",
                "generic-local",
                "In the Bouncy Castle JCE Provider version 1.55 and earlier ECDSA does not fully validate ASN.1 encoding of signature on verification. It is possible to inject extra elements in the sequence making up the signature and still have it validate, which in some cases may allow the introduction of 'invisible' data into a signed structure."
            ],
            [
                "Medium",
                "security",
                "WatcherOsher",
                "generic-local",
                "In the Bouncy Castle JCE Provider version 1.55 and earlier the DSA key pair generator generates a weak private key if used with default values. If the JCA key pair generator is not explicitly initialised with DSA parameters, 1.55 and earlier generates a private value assuming a 1024 bit key size. In earlier releases this can be dealt with by explicitly passing parameters to the key pair generator."
            ],
            [
                "Medium",
                "security",
                "WatcherOsher",
                "generic-local",
                "In the Bouncy Castle JCE Provider version 1.55 and earlier the DHIES/ECIES CBC mode vulnerable to padding oracle attack. For BC 1.55 and older, in an environment where timings can be easily observed, it is possible with enough observations to identify when the decryption is failing due to padding."
            ],
            [
                "Medium",
                "security",
                "WatcherOsher",
                "generic-local",
                "In the Bouncy Castle JCE Provider version 1.55 and earlier the other party DH public key is not fully validated. This can cause issues as invalid keys can be used to reveal details about the other party's private key where static Diffie-Hellman is in use. As of release 1.56 the key parameters are checked on agreement calculation."
            ],
            [
                "Medium",
                "security",
                "WatcherOsher",
                "generic-local",
                "imaaa"
            ],
            [
                "Medium",
                "security",
                "WatcherOsher",
                "generic-local",
                "The regular expression engine in JRuby before 1.4.1, when $KCODE is set to ?u?, does not properly handle characters immediately after a UTF-8 character, which allows remote attackers to conduct cross-site scripting (XSS) attacks via a crafted string."
            ],
            [
                "Medium",
                "security",
                "WatcherOsher",
                "generic-local",
                "Denial of Service (DoS)"
            ],
            [
                "Unknown",
                "security",
                "WatcherOsher",
                "generic-local",
                "Possible XML Injection"
            ],
            [
                "Medium",
                "security",
                "WatcherOsher",
                "generic-local",
                "A specially crafted ZIP archive can be used to cause an infinite loop inside of Apache Commons Compress' extra field parser used by the ZipFile and ZipArchiveInputStream classes in versions 1.11 to 1.15. This can be used to mount a denial of service attack against services that use Compress' zip package."
            ],
            [
                "Low",
                "security",
                "WatcherOsher",
                "generic-local",
                "asdasd"
            ],
            [
                "Information",
                "security",
                "WatcherOsher",
                "generic-local",
                "sawqinfo"
            ],
            [
                "Medium",
                "security",
                "WatcherOsher",
                "generic-local",
                "imale"
            ],
            [
                "Unknown",
                "security",
                "WatcherOsher",
                "generic-local",
                "[CVE-2015-6644] Information disclosure"
            ],
            [
                "Medium",
                "security",
                "WatcherOsher",
                "generic-local",
                "A JNDI Injection vulnerability exists in Jolokia agent version 1.3.7 in the proxy mode that allows a remote attacker to run arbitrary Java code on the server."
            ],
            [
                "Medium",
                "security",
                "WatcherOsher",
                "generic-local",
                "BouncyCastle TLS prior to version 1.0.3, when configured to use the JCE (Java Cryptography Extension) for cryptographic functions, provides a weak Bleichenbacher oracle when any TLS cipher suite using RSA key exchange is negotiated. An attacker can recover the private key from a vulnerable application. This vulnerability is referred to as \"ROBOT.\""
            ],
            [
                "High",
                "security",
                "WatcherOsher",
                "generic-local",
                "org.slf4j.ext.EventData in the slf4j-ext module in QOS.CH SLF4J before 1.8.0-beta2 allows remote attackers to bypass intended access restrictions via crafted data."
            ],
            [
                "Medium",
                "security",
                "WatcherOsher",
                "generic-local",
                "In the Bouncy Castle JCE Provider versions 1.51 to 1.55, a carry propagation bug was introduced in the implementation of squaring for several raw math classes have been fixed (org.bouncycastle.math.raw.Nat???). These classes are used by our custom elliptic curve implementations (org.bouncycastle.math.ec.custom.**), so there was the possibility of rare (in general usage) spurious calculations for elliptic curve scalar multiplications. Such errors would have been detected with high probability by the output validation for our scalar multipliers."
            ],
            [
                "Medium",
                "security",
                "WatcherOsher",
                "generic-local",
                "Denial of Service (DoS)"
            ],
            [
                "High",
                "security",
                "WatcherOsher",
                "generic-local",
                "Bouncy Castle BKS version 1 keystore (BKS-V1) files use an HMAC that is only 16 bits long, which can allow an attacker to compromise the integrity of a BKS-V1 keystore. All BKS-V1 keystores are vulnerable. Bouncy Castle release 1.47 introduces BKS version 2, which uses a 160-bit MAC."
            ],
            [
                "Medium",
                "security",
                "WatcherOsher",
                "generic-local",
                "An XSS vulnerability exists in the Jolokia agent version 1.3.7 in the HTTP servlet that allows an attacker to execute malicious javascript in the victim's browser."
            ],
            [
                "Medium",
                "security",
                "WatcherOsher",
                "generic-local",
                "Unbounded memory allocation in Google Guava 11.0 through 24.x before 24.1.1 allows remote attackers to conduct denial of service attacks against servers that depend on this library and deserialize attacker-provided data, because the AtomicDoubleArray class (when serialized with Java serialization) and the CompoundOrdering class (when serialized with GWT serialization) perform eager allocation without appropriate checks on what a client has sent and whether the data size is reasonable."
            ],
            [
                "Medium",
                "security",
                "WatcherOsher",
                "generic-local",
                "In the Bouncy Castle JCE Provider version 1.55 and earlier the DHIES implementation allowed the use of ECB mode. This mode is regarded as unsafe and support for it has been removed from the provider."
            ],
            [
                "Medium",
                "security",
                "WatcherOsher",
                "generic-local",
                "XStream through 1.4.9, when a certain denyTypes workaround is not used, mishandles attempts to create an instance of the primitive type 'void' during unmarshalling, leading to a remote application crash, as demonstrated by an xstream.fromXML(<voi) call."
            ],
            [
                "Medium",
                "security",
                "WatcherOsher",
                "generic-local",
                "In Hibernate Validator 5.2.x before 5.2.5 final, 5.3.x, and 5.4.x, it was found that when the security manager's reflective permissions, which allows it to access the private members of the class, are granted to Hibernate Validator, a potential privilege escalation can occur. By allowing the calling code to access those private members without the permission an attacker may be able to validate an invalid instance and access the private member value via ConstraintViolation#getInvalidValue()."
            ],
            [
                "Unknown",
                "security",
                "WatcherOsher",
                "generic-local",
                "Directory traversal in org.codehaus.plexus.util.Expand"
            ],
            [
                "Medium",
                "security",
                "WatcherOsher",
                "generic-local",
                "When reading a specially crafted ZIP archive, the read method of Apache Commons Compress 1.7 to 1.17's ZipArchiveInputStream can fail to return the correct EOF indication after the end of the stream has been reached. When combined with a java.io.InputStreamReader this can lead to an infinite stream, which can be used to mount a denial of service attack against services that use Compress' zip package."
            ],
            [
                "Medium",
                "security",
                "WatcherOsher",
                "generic-local",
                "In Bouncy Castle JCE Provider version 1.55 and earlier the DSA does not fully validate ASN.1 encoding of signature on verification. It is possible to inject extra elements in the sequence making up the signature and still have it validate, which in some cases may allow the introduction of 'invisible' data into a signed structure."
            ],
            [
                "Medium",
                "security",
                "WatcherOsher",
                "generic-local",
                "Deserialization of Untrusted Data"
            ],
            [
                "Medium",
                "security",
                "WatcherOsher",
                "generic-local",
                "In the Bouncy Castle JCE Provider version 1.55 and earlier the ECIES implementation allowed the use of ECB mode. This mode is regarded as unsafe and support for it has been removed from the provider."
            ]
        ]
        const severitiesColors = {
            high: "d73f3f",
            medium: "fb8c00",
            low: "00569a",
            unknown: "707070"
        }

// Only pt supported (not mm or in)
        let doc = new jsPDF('p', 'pt');
        let totalPagesExp = "{total_pages_count_string}"
        if (doc.autoTable.previous) {
            doc.autoTable.previous.finalY = 0
        }
        let start = 60;
        let severities = ["critical", "minor", "major", "high", "low", "medium", "unknown", "information"]
        doc.autoTable(columns, rows, {
            showHeader: 'everyPage',
            addPageContent: (data) => {
                if (data.pageCount == 1) {
                    doc.text(`Violations of ${this.$widgetObject.model.sharedData.compDetails.general_details.package_name} (${rows.length})`, data.settings.margin.left, 20);
                }
                // FOOTER
                let str = "Page " + data.pageCount;
                // Total page number plugin only available in jspdf v1.0+
                if (typeof doc.putTotalPages === 'function') {
                    str = str + " of " + totalPagesExp + " Generated by JFrog Xray";
                }
                doc.setFontSize(10);
                let pageHeight = doc.internal.pageSize.height || doc.internal.pageSize.getHeight();
                doc.text(str, data.settings.margin.left, pageHeight - 10);
                let imgData = 'data:image/png;base64,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';


                doc.setFontSize(40);
                doc.addImage(imgData, 'PNG', 180, pageHeight - 23, 20, 20); // img,type,left , top ,width,height

            },
            createdCell: function (cell, data) {

                if (_.includes(severities, cell.raw.toLowerCase())) {
                    cell.styles.fillColor = severitiesColors[cell.raw.toLowerCase()] || "707070";
                    cell.styles.textColor = "fff";
                    cell.styles.valign = "middle";
                    cell.styles.halign = "center";
                    cell.styles.fontStyle = "bold";
                }

                if (data.column.raw.toLowerCase() === 'summary') {
                    cell.styles.halign = "left";
                }

            },
            theme: 'grid',

            startY: start,
            margin: {horizontal: 7},
            bodyStyles: {valign: 'top'},
            styles: {overflow: 'linebreak', columnWidth: 'wrap', halign: "center"},
            headerStyles: {
                fillColor: [67, 160, 71],
                fontSize: 10,
                halign: "center",
                valign: "middle"
            },
            columnStyles: {
                0: {columnWidth: 70},
                1: {columnWidth: 50},
                2: {columnWidth: 100},
                3: {columnWidth: 110},
                4: {columnWidth: 250}
                // etc
            },


        });
        if (typeof doc.putTotalPages === 'function') {
            doc.putTotalPages(totalPagesExp);
        }
        doc.save(`${this.$widgetObject.model.sharedData.compDetails.general_details.package_name}-${this.versionOfComp}.pdf`);
        doc.autoTable.previous.finalY = 0
    }

}




// WEBPACK FOOTER //
// ./modules/xray/componentsPage_widgets/main_details_container/main_details_container.controller.js